export default function ToBe() {
  return (
    <table className="table_sticky">
      <tbody>
        <tr style={{ fontWeight: "bold" }}>
          <th> </th>
          <th> present </th>
          <th> past </th>
          <th> future </th>
          <th> conditional </th>
          <th> imperative </th>
        </tr>
        <tr>
          <th> ja </th>
          <td> jesm </td>
          <td> byl (-a) </td>
          <td> budem </td>
          <td> by byl (-a) </td>
          <td> — </td>
        </tr>
        <tr>
          <th> ty </th>
          <td> jesi </td>
          <td> byl (-a) </td>
          <td> budeš </td>
          <td> by byl (-a) </td>
          <td> budi </td>
        </tr>
        <tr>
          <th>
            on
            <br />
            ona
            <br />
            ono
          </th>
          <td> jest </td>
          <td>
            byl
            <br />
            byla
            <br />
            bylo
          </td>
          <td> bude </td>
          <td>
            by byl
            <br />
            by byla
            <br />
            by bylo
          </td>
          <td> — </td>
        </tr>
        <tr>
          <th> my </th>
          <td> jesmo </td>
          <td> byli </td>
          <td> budemo </td>
          <td> by byli </td>
          <td> budimo </td>
        </tr>
        <tr>
          <th> vy </th>
          <td> jeste </td>
          <td> byli </td>
          <td> budete </td>
          <td> by byli </td>
          <td> budite </td>
        </tr>
        <tr>
          <th> oni </th>
          <td> sut </td>
          <td> byli </td>
          <td> budut </td>
          <td> by byli </td>
          <td> — </td>
        </tr>
      </tbody>
    </table>
  )
}
